import syntheseAnalyseApi from '@/api/synthese-analyse.api'

const getDefaultState = () => {
  return {
    syntheseAnalyse: []
  }
}

const module = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    syntheseAnalyse (state) {
      return state.syntheseAnalyse
    },
  },

  mutations: {
    UPDATE_SYNTHESE_ANALYSE (state, syntheseAnalyse) {
      state.syntheseAnalyse = syntheseAnalyse
    },
    RESET (state) {
      Object.assign(state, getDefaultState())
    }
  },

  actions: {
    getSyntheseAnalyse ({ commit, rootGetters }) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return syntheseAnalyseApi.getSyntheseAnalyse(username, anneeRecolte)
        .then(response => {
          commit('UPDATE_SYNTHESE_ANALYSE', response)
        })
    },
    saveOrdreSyntheseAnalyse ({ commit, rootGetters }, syntheseAnalyse) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return syntheseAnalyseApi.saveOrdreSyntheseAnalyse(username, anneeRecolte, syntheseAnalyse)
        .then(response => {
          commit('UPDATE_SYNTHESE_ANALYSE', response)
        })
    },
    createOrUpdateSyntheseAnalyse ({ dispatch, rootGetters }, syntheseAnalyse) {

      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      let promiseUpdate
      if (syntheseAnalyse.id) {
        promiseUpdate = syntheseAnalyseApi.updateSyntheseAnalyse(username, anneeRecolte, syntheseAnalyse)
      } else {
        syntheseAnalyse['numtiers'] = username
        syntheseAnalyse['anneeRecolte'] = anneeRecolte
        promiseUpdate = syntheseAnalyseApi.createSyntheseAnalyse(username, anneeRecolte, syntheseAnalyse)
      }
      return promiseUpdate.then(() => dispatch('getSyntheseAnalyse'))
    },
    deleteSyntheseAnalyse ({ dispatch, rootGetters }, syntheseAnalyse) {
      let username = rootGetters['adherent/numtiers'] != null ? rootGetters['adherent/numtiers'] : rootGetters['user/profil'].username
      const anneeRecolte = rootGetters['application/anneeRecolteActive'] != null ? rootGetters['application/anneeRecolteActive'] : rootGetters['application/anneeRecolteEnCours']
      return syntheseAnalyseApi.deleteSyntheseAnalyse(username, anneeRecolte, syntheseAnalyse.id)
        .then(() => dispatch('getSyntheseAnalyse'))
    },
    reset ({ commit }) {
      commit('RESET')
    }
  }
}

export default module
